/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NotificationRuleMonitorDto = {
    id: string;
    monitorTemplate: NotificationRuleMonitorDto.monitorTemplate;
    name: string;
};

export namespace NotificationRuleMonitorDto {

    export enum monitorTemplate {
        COMPLETENESS = 'COMPLETENESS',
        DUPLICATES = 'DUPLICATES',
        FRESHNESS = 'FRESHNESS',
        SCHEMA_CHANGE = 'SCHEMA_CHANGE',
        METADATA_FRESHNESS = 'METADATA_FRESHNESS',
        NUMERICAL_TRANSFORMATION = 'NUMERICAL_TRANSFORMATION',
        INTERLINKED_METRICS = 'INTERLINKED_METRICS',
        CUSTOM_METRICS = 'CUSTOM_METRICS',
        DISTRIBUTION = 'DISTRIBUTION',
        UNIQUE = 'UNIQUE',
        REFERENTIAL_INTEGRITY = 'REFERENTIAL_INTEGRITY',
        NOT_IN_LIST = 'NOT_IN_LIST',
        COUNT_DUPLICATE = 'COUNT_DUPLICATE',
        COUNT_NULL_ROWS = 'COUNT_NULL_ROWS',
        RANGE = 'RANGE',
        IS_EMAIL = 'IS_EMAIL',
        IS_PHONE_NUMBER = 'IS_PHONE_NUMBER',
        IS_UUID = 'IS_UUID',
        MATCHES_REGEX = 'MATCHES_REGEX',
        NO_CODE = 'NO_CODE',
        SQL_CONDITION = 'SQL_CONDITION',
        SQL = 'SQL',
        DBT = 'DBT',
        __OBSOLETE__COMPLETENESS_STATIC = '__OBSOLETE__COMPLETENESS_STATIC',
        __OBSOLETE__STATIC_COUNT_DUPLICATE = '__OBSOLETE__STATIC_COUNT_DUPLICATE',
        __OBSOLETE__DUPLICATE = '__OBSOLETE__DUPLICATE',
        __OBSOLETE__NULL = '__OBSOLETE__NULL',
        __OBSOLETE__PERCENTAGE_NULL_STATIC = '__OBSOLETE__PERCENTAGE_NULL_STATIC',
        __OBSOLETE__AVERAGE = '__OBSOLETE__AVERAGE',
        __OBSOLETE__COUNT = '__OBSOLETE__COUNT',
        __OBSOLETE__QUANTILE = '__OBSOLETE__QUANTILE',
        __OBSOLETE__SUM = '__OBSOLETE__SUM',
        __OBSOLETE__STANDARD_DEVIATION = '__OBSOLETE__STANDARD_DEVIATION',
        __OBSOLETE__VARIANCE = '__OBSOLETE__VARIANCE',
        __OBSOLETE__PERCENTAGE_NULL_ROWS = '__OBSOLETE__PERCENTAGE_NULL_ROWS',
        __OBSOLETE__PERCENTAGE_DUPLICATES = '__OBSOLETE__PERCENTAGE_DUPLICATES',
    }


}
